var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHerogame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 124,
    viewBox: "0 0 124 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4419_239083)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 36.6016,
    y: 36.9624,
    width: 50,
    height: 50,
    rx: 10,
    fill: "#36B696"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.1016,
    y: 38.4624,
    width: 47,
    height: 47,
    rx: 8.5,
    stroke: "white",
    strokeOpacity: 0.1,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.705 73.9292C56.6606 74.0403 55.3997 74.0123 53.9224 73.8452C52.445 73.6781 51.317 73.4061 50.5384 73.0292C50.2273 72.3181 49.9659 71.207 49.7544 69.6959C49.5428 68.1848 49.493 66.8959 49.605 65.8292L57.705 73.9292ZM60.8717 73.3959L50.1384 62.6625C50.5161 60.9959 51.0664 59.479 51.789 58.1119C52.5117 56.7448 53.3504 55.5728 54.305 54.5959C55.2606 53.6403 56.4219 52.8128 57.789 52.1132C59.1561 51.4136 60.6281 50.8856 62.205 50.5292L73.005 61.3292C72.6495 62.9736 72.1272 64.4848 71.4384 65.8625C70.7495 67.2403 69.9272 68.407 68.9717 69.3625C67.9717 70.3403 66.777 71.1794 65.3877 71.8799C63.9984 72.5803 62.493 73.0856 60.8717 73.3959ZM58.1384 67.2959L66.9384 58.4959L65.0717 56.6292L56.2717 65.4292L58.1384 67.2959ZM73.5384 58.1625L65.4384 49.9959C66.505 49.8625 67.8161 49.8848 69.3717 50.0625C70.9272 50.2403 72.0272 50.5181 72.6717 50.8959C73.0717 51.7848 73.3495 52.935 73.505 54.3465C73.6606 55.7581 73.6717 57.0301 73.5384 58.1625Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4419_239083",
    x: 0.146896,
    y: 0.507736,
    width: 122.909,
    height: 122.909,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 18.2273
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.211765 0 0 0 0 0.713726 0 0 0 0 0.588235 0 0 0 0.75 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4419_239083"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4419_239083",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHerogame);
export default __webpack_public_path__ + "static/media/herogame.c721903ba97596ef0a323ad16273283d.svg";
export { ForwardRef as ReactComponent };